import FApiRoutes from '../api/FApiRoutes';
import {
  IApiBlogEntry,
  IApiBox,
  IApiQuickLink,
  IApiSlide,
  IApiSocialMedia,
} from '../common/interfaces/api.interface';

export default class FApiService {
  public async getBlogEntries(): Promise<IApiBlogEntry[]> {
    const response = await FApiRoutes.getBlogEntries.fetch();
    return response.data;
  }

  public async getBoxes(): Promise<IApiBox[]> {
    const response = await FApiRoutes.getBoxes.fetch();
    return response.data;
  }

  public async getQuickLinks(): Promise<IApiQuickLink[]> {
    const response = await FApiRoutes.getQuickLinks.fetch();
    return response.data;
  }

  public async getSlides(): Promise<IApiSlide[]> {
    const response = await FApiRoutes.getSlides.fetch();
    return response.data;
  }

  public async getSocialMedias(): Promise<IApiSocialMedia[]> {
    const response = await FApiRoutes.getSocialMedias.fetch();
    return response.data;
  }
}
